module.exports = __webpack_public_path__ + "img/mb_hm_block01_en.da10b8bb.jpg";